import { createApiRef } from '@backstage/core-plugin-api';

export interface SummaryResponse {
  totalRuns: number;
  componentsCreated: number;
  distinctTemplates: number;
  distinctUsers: number;
  topTemplate: { templateRef: string; title: string; totalRuns: number } | null;
  firstRunAt: string | null;
  lastRunAt: string | null;
}

export interface TemplateStat {
  templateRef: string;
  title: string;
  totalRuns: number;
  distinctUsers: number;
  firstUsedAt: string;
  lastUsedAt: string;
}

export interface SystemStat {
  systemRef: string;
  systemName: string;
  runs: number;
  components: number;
}

export interface OverTimeBucket {
  bucket: string;
  count: number;
}

export interface ComponentRow {
  componentRef: string;
  componentName: string;
  componentNamespace: string;
  systemRef: string | null;
  systemName: string | null;
  templateRef?: string;
  templateTitle?: string;
  createdBy: string | null;
  createdAt: string;
  inCatalog: boolean;
}

export type OverTimePeriod = 'day' | 'week' | 'month';

export interface TdpStatisticApi {
  getSummary(): Promise<SummaryResponse>;
  getTemplates(): Promise<TemplateStat[]>;
  getSystems(): Promise<SystemStat[]>;
  getOverTime(
    period?: OverTimePeriod,
    templateRef?: string,
  ): Promise<OverTimeBucket[]>;
  getComponents(): Promise<ComponentRow[]>;
}

export const tdpStatisticApiRef = createApiRef<TdpStatisticApi>({
  id: 'plugin.tdp-statistic.api',
});
